<template>
  <div class="dropdown-with-checkbox" :style="`padding-left: ${identation * 1}rem; width: 100%;`" @click="handleClick">
    <IndeterminateCheckbox :indeterminate="indeterminate" :checked="checked"/>
    <span>{{ label }}</span>
  </div>
</template>
<script>
import IndeterminateCheckbox from "./IndeterminateCheckbox"

export default {
  name: "dropdown-with-checkbox",
  components: {
    IndeterminateCheckbox
  },
  model: {
    prop: "checked"
  },
  props: {
    checked: {
      type: Boolean,
      description: "Whether checkbox is checked"
    },
    indeterminate: {
      type: Boolean,
      description: "Whether checkbox is indeterminate"
    },
    label: {
      type: String,
      description: "Label of the dropdown element"
    },
    onClick: {
      type: Function,
      description: "On click callback"
    },
    identation: {
      type: Number,
      description: "The number of visual tabs of the checkbox",
      default: 1
    }
  },
  methods: {
    handleClick() {
      this.onClick();
    }
  }
};
</script>
<style>
.dropdown-with-checkbox {
  display: flex;
  align-items: center;
  padding: .5rem 1rem;
  font-size: 14px;
  transition: background-color 0.1s ease;
}

.dropdown-with-checkbox:hover {
  background-color: #f8f9fa;
}
.dropdown-with-checkbox:active {
  background-color: #bbec85;
}
</style>
